import { createContext } from 'react';
import { ReactReduxContextValue } from 'react-redux';

export const ApiContext = createContext<{ [key: string]: any }>({});
export const GlobalApiContext = createContext<{ [key: string]: any }>({});
export const StateContext = createContext<ReactReduxContextValue | null>(null);
export const GlobalStateContext = createContext<ReactReduxContextValue | null>(
  null,
);
